import React, { useState } from 'react';
import { RouteComponentProps } from 'react-router';

import { EarningFilterContainer } from '../../epic/earning-filter';
import { EarningCreateContainer } from '../../epic/earning-create';
import styled from 'styled-components';
import { Spacing } from '../../theme';
import { EarningAdminListContainer } from '../../epic/earning-admin-list';

export const Page: React.FC<RouteComponentProps> = () => {
  const [payload, setPayload] = useState<{
    status: string;
    eventId?: string;
    userId?: string | number;
    startDate?: string;
    endDate?: string;
  }>();

  return (
    <Container>
      <EarningFilterContainer setPayload={setPayload} />
      <EarningCreateContainer />
      <EarningAdminListContainer payload={payload} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing(4)};
  width: 100%;
  max-width: 400px;
`;
